import { createContext, useContext, useReducer } from "react";

// interface ConfirmContext {
//   show: boolean;
//   title: string,
//   content: string | JSX.Element;
// }
const initSub = {
  show: false,
  title: "",
  content: "",
};
const initialState = {
  confirm: { ...initSub },
  info: { ...initSub },
};
const PopupContext = createContext(initialState);

const SHOW_CONFIRM = "SHOW_CONFIRM";
const HIDE_CONFIRM = "HIDE_CONFIRM";
const SHOW_INFO = "SHOW_INFO";
const HIDE_INFO = "HIDE_INFO";

const reducer = (state = initialState, action,) => {
  switch (action.type) {
    case SHOW_CONFIRM:
      return {
        ...state,
        confirm: {
          show: true,
          type: "confirm",
          title: action.payload.title,
          content: action.payload.content,
        }
      };
    case HIDE_CONFIRM:
      return { ...state, confirm: { ...initSub } };
    case SHOW_INFO:
      return {
        ...state,
        info: {
          show: true,
          type: "info",
          title: action.payload.title,
          content: action.payload.content,
        }
      };
    case HIDE_INFO:
      return { ...state, info: { ...initSub } };
    default:
      return initialState;
  }
};
const PopupContextProvider = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialState);

  return (
    <PopupContext.Provider value={[state, dispatch]}>
      {children}
    </PopupContext.Provider>
  );
};
let resolveCallback;
function useConfirm() {
  const [state, dispatch] = useContext(PopupContext);
  const onConfirm = () => {
    closeConfirm();
    resolveCallback(true);
  };

  const onCancel = () => {
    closeConfirm();
    resolveCallback(false);
  };
  const confirm = (content, title = "確認") => {
    dispatch({
      type: SHOW_CONFIRM,
      payload: { title, content }
    });
    return new Promise((res, rej) => {
      resolveCallback = res;
    });
  };

  const closeConfirm = () => {
    dispatch({
      type: HIDE_CONFIRM
    });
  };

  return { confirm, onConfirm, onCancel, confirmState: state.confirm };
}
function useInfo() {
  const [state, dispatch] = useContext(PopupContext);

  const onClose = () => {
    closeInfo();
    resolveCallback(false);
  };
  const showInfo = (content, title = "情報") => {
    dispatch({
      type: SHOW_INFO,
      payload: { title, content }
    });
    return new Promise((res, rej) => {
      resolveCallback = res;
    });
  };

  const closeInfo = () => {
    dispatch({
      type: HIDE_INFO
    });
  };

  return { showInfo, onClose, infoState: state.info };
}
/*
function usePopup() {
  const [popupState, dispatch] = useContext(PopupContext);
  const onClose = () => {
    close();
  };
  const popup = (content) => {
    dispatch({
      type: SHOW_CONFIRM,
      payload: { title: "alert", content }
    });
    return new Promise((res, rej) => {
      resolveCallback = res;
    });
  };

  const close = () => {
    dispatch({
      type: HIDE_CONFIRM
    });
  };

  return { popup, popupState };
}
*/

export {
  useConfirm,
  useInfo,
  PopupContextProvider
}
